import feathers from "@feathersjs/feathers";
import socketio from "@feathersjs/socketio-client";
import auth from "@feathersjs/authentication-client";
import io from "socket.io-client";
import { iff, discard } from "feathers-hooks-common";
import feathersVuex from "feathers-vuex";
import Notify from 'quasar/src/plugins/Notify.js';;

import store from "store";

const socket = io(process.env.VUE_APP_API_SERVER, { transports: ['websocket'] })

const feathersClient = feathers()
  .configure(
    socketio(socket, {
      timeout: 15000,
    })
  )
  .configure(
    auth({
      storage: window.localStorage,
      storageKey: process.env.VUE_APP_STORAGE_KEY,
    })
  )
  .hooks({
    before: {
      all: [
        async (context) => {
          const { params, id, path, method, data } = context;
          if (params?.merchant) delete params.merchant
          if (process.env.NODE_ENV !== 'production') console.log("API QUERY", {
            params,
            id,
            path,
            method,
            data
          });
        },

        iff(
          (context) => ["create", "update", "patch"].includes(context.method),
          discard("__id", "__isTemp")
        ),
      ],
    },

    error: {
      all: [
        async context => {
          if (process.env.NODE_ENV !== 'production') console.log("************ API ERROR", context.error);
        }
      ]
    }
  });

export default feathersClient;

// Setup feathers-vuex, for more information see: https://vuex.feathersjs.com/getting-started.html#global-configuration
const {
  makeServicePlugin,
  makeAuthPlugin,
  BaseModel,
  models,
  // clients,
  FeathersVuex,
} = feathersVuex(feathersClient, {
  debug: false,
  serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
  idField: 'id', // Must match the id field in your database table/collection
  whitelist: ['$regex', '$options']
});

export {
  makeAuthPlugin,
  makeServicePlugin,
  BaseModel,
  models,
  // clients,
  FeathersVuex,
  // socket,
};
